document.addEventListener('DOMContentLoaded', () => {
  const wishlistKey = 'arbasa:wishlist';

  const hydrateImage = (image) => {
    if (!image) return;
    if (image.dataset.src) {
      image.src = image.dataset.src;
      delete image.dataset.src;
    }
    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      delete image.dataset.srcset;
    }
  };

  const observeLazyImages = () => {
    const images = Array.from(document.querySelectorAll('[data-card-primary-lazy], [data-department-lazy-image]'));
    if (!images.length) return;

    if (!('IntersectionObserver' in window)) {
      images.forEach((image) => {
        hydrateImage(image);
        image.removeAttribute('data-card-primary-lazy');
        image.removeAttribute('data-department-lazy-image');
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const image = entry.target;
        hydrateImage(image);
        image.removeAttribute('data-card-primary-lazy');
        image.removeAttribute('data-department-lazy-image');
        observer.unobserve(image);
      });
    }, { rootMargin: '220px 0px' });

    images.forEach((image) => observer.observe(image));
  };

  const readWishlist = () => {
    try {
      const saved = JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    window.localStorage.setItem(wishlistKey, JSON.stringify(items));
  };

  const updateWishlistButtons = () => {
    const items = readWishlist();
    const savedHandles = new Set(items.map((item) => item.handle));

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const handle = button.dataset.productHandle;
      const isSaved = savedHandles.has(handle);
      const title = button.dataset.productTitle || 'this product';
      const label = button.querySelector('[data-wishlist-label]');

      button.classList.toggle('is-saved', isSaved);
      button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      button.setAttribute('aria-label', `${isSaved ? 'Remove' : 'Save'} ${title}`);
      if (label) label.textContent = isSaved ? 'Saved' : 'Save';
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;
    if (!handle) return;

    const items = readWishlist();
    const existingIndex = items.findIndex((item) => item.handle === handle);

    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
    } else {
      items.push({
        handle,
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || `/products/${handle}`,
        savedAt: new Date().toISOString(),
      });
    }

    writeWishlist(items);
    updateWishlistButtons();
    window.dispatchEvent(new CustomEvent('arbasa:wishlist-change', { detail: { items } }));
  });

  updateWishlistButtons();

  document.querySelectorAll('[data-menu]').forEach((menu) => {
    const trigger = menu.querySelector('.departments-menu__trigger');
    const panel = menu.querySelector('.departments-menu__panel');
    const items = Array.from(menu.querySelectorAll('.departments-menu__item'));
    let closeTimer;

    const setActive = (item) => {
      items.forEach((menuItem) => menuItem.classList.toggle('is-active', menuItem === item));
    };

    const openMenu = () => {
      window.clearTimeout(closeTimer);
      menu.classList.add('is-hovered');
    };

    const scheduleClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        menu.classList.remove('is-hovered');
      }, 180);
    };

    trigger?.addEventListener('click', (event) => {
      event.preventDefault();
      menu.classList.toggle('is-open');
      menu.classList.add('is-hovered');
    });

    menu.querySelector('[data-menu-close]')?.addEventListener('click', () => {
      menu.classList.remove('is-open', 'is-hovered');
      trigger?.focus();
    });

    menu.addEventListener('mouseenter', openMenu);
    menu.addEventListener('mouseleave', scheduleClose);
    trigger?.addEventListener('focus', openMenu);
    panel?.addEventListener('mouseenter', openMenu);

    const isMobileMenu = () => window.matchMedia('(max-width: 640px)').matches;

    items.forEach((item) => {
      const dept = item.querySelector('.departments-menu__dept');
      item.addEventListener('mouseenter', () => {
        if (isMobileMenu()) return;
        setActive(item);
      });
      item.addEventListener('focusin', () => {
        if (isMobileMenu()) return;
        setActive(item);
      });
      dept?.addEventListener('click', (event) => {
        if (!isMobileMenu() || !menu.classList.contains('is-open')) return;
        event.preventDefault();
        if (item.classList.contains('is-active')) {
          item.classList.remove('is-active');
        } else {
          setActive(item);
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!menu.contains(event.target)) {
        menu.classList.remove('is-open', 'is-hovered');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        menu.classList.remove('is-open', 'is-hovered');
        trigger?.focus();
      }
    });

    if (items[0]) setActive(items[0]);
  });

  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const images = Array.from(card.querySelectorAll('[data-card-image]'));
    const dots = Array.from(card.querySelectorAll('[data-card-dot]'));
    const prev = card.querySelector('[data-card-prev]');
    const next = card.querySelector('[data-card-next]');
    let active = 0;

    if (images.length < 2) return;

    const loadImage = (image) => {
      if (!image || !('cardLazyImage' in image.dataset)) return;
      hydrateImage(image);
      delete image.dataset.cardLazyImage;
    };

    const show = (index) => {
      active = (index + images.length) % images.length;
      loadImage(images[active]);
      images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === active));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
    };

    prev?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      show(active - 1);
    });

    next?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      show(active + 1);
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        show(index);
      });
    });

    show(0);
  });

  observeLazyImages();

  document.querySelectorAll('[data-predictive-search-form]').forEach((form) => {
    const input = form.querySelector('[data-predictive-search-input]');
    const results = form.querySelector('[data-predictive-search-results]');
    let controller;

    input?.addEventListener('input', async () => {
      const query = input.value.trim();
      if (!results) return;
      if (query.length < 2) {
        results.hidden = true;
        results.replaceChildren();
        return;
      }

      controller?.abort();
      controller = new AbortController();

      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`, {
          signal: controller.signal,
          headers: { Accept: 'application/json' }
        });
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        results.replaceChildren();

        if (!products.length) {
          const empty = document.createElement('span');
          empty.textContent = 'No products found';
          results.append(empty);
        } else {
          products.forEach((product) => {
            const link = document.createElement('a');
            link.href = product.url;
            link.textContent = product.title;
            results.append(link);
          });
        }

        results.hidden = false;
      } catch (error) {
        if (error.name !== 'AbortError') results.hidden = true;
      }
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target) && results) results.hidden = true;
    });
  });

  document.querySelectorAll('product-recommendations[data-url]').forEach(async (container) => {
    try {
      const response = await fetch(container.dataset.url);
      if (!response.ok) return;
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const recommendations = html.querySelector('product-recommendations');
      if (recommendations?.innerHTML.trim()) {
        container.innerHTML = recommendations.innerHTML;
      }
    } catch (error) {
      container.hidden = true;
    }
  });

  document.querySelectorAll('[data-facet-form]').forEach((form) => {
    const minRange = form.querySelector('[data-price-min-range]');
    const maxRange = form.querySelector('[data-price-max-range]');
    const minInput = form.querySelector('[data-price-min-input]');
    const maxInput = form.querySelector('[data-price-max-input]');

    minRange?.addEventListener('input', () => {
      if (!minInput) return;
      minInput.value = minRange.value;
      if (maxInput && Number(minInput.value) > Number(maxInput.value)) maxInput.value = minInput.value;
    });

    maxRange?.addEventListener('input', () => {
      if (!maxInput) return;
      maxInput.value = maxRange.value;
      if (minInput && Number(maxInput.value) < Number(minInput.value)) minInput.value = maxInput.value;
    });

    form.querySelectorAll('input, select').forEach((control) => {
      control.addEventListener('change', () => {
        if (control === minRange && minInput) minInput.value = minRange.value;
        if (control === maxRange && maxInput) maxInput.value = maxRange.value;
        form.submit();
      });
    });
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch || form.dataset.noAjaxCart === 'true') return;
      event.preventDefault();

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) {
          form.submit();
          return;
        }

        const item = await response.json();
        const notification = document.querySelector('#CartNotification');
        const notificationText = notification?.querySelector('[data-cart-notification-text]');
        if (notificationText) notificationText.textContent = `${item.title || 'Item'} added successfully.`;
        notification?.classList.add('is-open');
        notification?.setAttribute('aria-hidden', 'false');
        window.setTimeout(() => {
          notification?.classList.remove('is-open');
          notification?.setAttribute('aria-hidden', 'true');
        }, 3200);

        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((cartResponse) => cartResponse.json());
        document.querySelectorAll('.site-actions a[href*="/cart"] strong').forEach((count) => {
          count.textContent = cart.item_count;
        });
      } catch (error) {
        form.submit();
      }
    });
  });

  document.querySelectorAll('[data-cart-drawer-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const drawer = document.querySelector('#CartDrawer');
      drawer?.classList.remove('is-open');
      drawer?.setAttribute('aria-hidden', 'true');
    });
  });

  document.querySelectorAll('[data-address-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (!target) return;
      const shouldOpen = target.hidden;
      target.hidden = !shouldOpen;
      button.setAttribute('aria-expanded', String(shouldOpen));
      button.textContent = shouldOpen ? 'Cancel edit' : 'Edit';
    });
  });
});
